import React from 'react';
import './destination-details.scss';
import { SVGS } from '../../../assets';
import { InputWrapper } from '../input-wrapper';
import { TouchableOpacity } from '../../../common';

const destination_Details = [
  {
    key: 'cityName',
    label: 'Enter the address info',
    placeholder: 'Enter City Name',
    icon: SVGS.CityIcon,
  },
  {
    key: 'Pincode',
    label: '',
    placeholder: 'Enter Pincode',
    icon: SVGS.Pincode,
    maxLength: 6,
    type: 'tel',
  },
  {
    key: 'address',
    label: '',
    placeholder: 'Please Provide Address',
    icon: SVGS.Location,
  },
];

interface DestinationDetailsProps {
  formData: Record<string, string | string[]>;
  onChange: (key: string, value: string) => void;
  isEnabled?: boolean;
  onCheckBoxPress?: () => void;
}

export const DestinationDetails: React.FC<DestinationDetailsProps> = ({
  formData,
  onChange,
  isEnabled = false,
  onCheckBoxPress,
}) => {
  return (
    <div className="destination-details">
      {destination_Details.map((field) => (
        <div key={field.key} className="destination-details--field">
          {field.label && (
            <label className="destination-details--label font-medium">
              {field.label}
            </label>
          )}

          <InputWrapper
            icon={field.icon}
            placeholder={field.placeholder}
            value={(formData[field.key] as string) ?? ''}
            onChange={(value) => onChange(field.key, value)}
            maxLength={field.maxLength}
            type={field.type}
          />
        </div>
      ))}

      <TouchableOpacity
        className="destination-details--checkbox-view"
        onPress={onCheckBoxPress}
      >
        <img src={isEnabled ? SVGS.CheckboxBlack : SVGS.UncheckedBox} />
        <span className="destination-details--checkbox-text font-medium">
          {'Update the customer master'}
        </span>
      </TouchableOpacity>
    </div>
  );
};
